<template>
  <div class="px-4 sm:px-6 lg:px-8">
    <div class="mt-8 flow-root">
      <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="inline-block min-w-full py-2 align-middle">
          <table class="min-w-full divide-y divide-gray-300">
            <thead>
            <tr>
              <th scope="col" class="py-3.5 px-3 text-left text-sm font-semibold text-gray-900">Item</th>
              <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Qty</th>
              <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-900">Warehouse</th>
            </tr>
            </thead>
            <tbody class="divide-y divide-gray-200 bg-white">
            <tr v-if="value.items && value.items.length === 0">
              <td colspan="3" class="text-center text-gray-400 text-sm py-4">No item selected</td>
            </tr>
            <tr
              v-for="(item, i) in value.items"
              :key="'detail-item-'+item.id"
              :class="{'bg-red-50': isDisabled(item)}"
            >
              <td class="whitespace-nowrap py-4 px-3 text-sm font-medium text-gray-900">
                <div>
                  <label class="flex gap-x-3">
                    <span v-if="!isSplit && enabled" class="pr-2">
                      <input type="checkbox"
                             :value="item.id"
                             @input="onSelect($event, item)"
                             :checked="item.selected"
                             v-model="item.selected"
                             :disabled="isDisabled(item)"
                             class="h-4 w-4"
                      />
                    </span>
                    <span class="flex flex-col">
                      <span>{{ item.description }}</span>
                      <span class="mt-1 italic text-xs text-gray-400 ">
                        {{ item.item_code }}
                      </span>
                    </span>
                  </label>
                </div>
              </td>
              <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-500 flex items-center">
                <template v-if="isSplit">
                  <FormInput
                    type="number"
                    v-model.number="item.quantity_splited"
                    @input="onQuantityChange(item)"
                    class="w-20 py-0 -my-1"
                    :errors="getError(i, 'quantity_splited')"
                    state
                  />
                  <span class="px-2">/ {{ item.quantity_assigned }} {{ item.unit }}</span>
                  <AvailableQtyBadge
                    v-if="available_qty.loaded"
                    :item="available_qty.items[item.item_code]"
                    :unit="item.unit"
                    :qty="item.quantity_splited"
                  />
                </template>
                <template v-else>
                  <div class="flex gap-x-2 text-sm font-bold">
                    <div class="w-16">
                      {{ item.quantity_pending }}
                    </div>
                    <div>{{ item.unit }}</div>
                  </div>
                </template>
              </td>
              <td class="whitespace-nowrap pl-3 pr-4 py-4 text-sm text-gray-500">
                <template v-if="isSplit">
                  <SelectInput
                    class="py-0 -my-1"
                    v-model="item.warehouse_id"
                    @input="fetchAvailableQty(item)"
                  >
                    <option v-for="(warehouse, windx) in getWarehouseListFor(item.item_code)" :value="warehouse.id" :key="windx">{{ warehouse.name }}</option>
                  </SelectInput>
                </template>
                <template v-else-if="item.warehouse">
                  {{ item.warehouse.name }}
                </template>
                <template v-else>
                  N/A
                </template>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormInput from "../../../Shared/Form/FormInput.vue";
import {cloneDeep} from "lodash";
import SelectInput from "../../../Shared/SelectInput.vue";
import AvailableQtyBadge from "../../../Shared/AvailableQtyBadge.vue";

export default {
  name: 'NoteDetailItems',
  components: {AvailableQtyBadge, SelectInput, FormInput},
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          type: 'delivery',
          items: [],
        }
      }
    },
    errors: null,
    selected: Array,
    warehouses: Array,
    type: {
      type: String,
      default: 'delivery',
    },
    orderId: Number,
    enabled: Boolean,
    handoverItems: {
      type: Array,
      default: () => [],
    },
    canHandoverItemsToCustomer: Boolean,
    isSplit: Boolean,
    getWarehouseListFor: Function,
  },

  data() {
    return {
      available_qty: {
        loaded: false,
        items: {}
      },
    }
  },

  computed: {
    // isSplit() {
    //   return this.value.type !== this.type
    // },
    getError() {
      return (index, fieldName) => {
        const errorKey = `splits.items.${index}.${fieldName}`;
        if (Object.keys(this.errors).length) {
          return this.errors[errorKey];
        }
        return []
      }
    }
  },

  methods: {
    reduceQuantity(item) {
      let newValue = {
        ...this.value,
        items: this.value.items.map(itm =>
          itm.id === item.id
            ? { ...itm, quantity_pending: itm.quantity_pending - item.quantity_splited }
            : itm
        ),
      };
      this.$emit('input', newValue);

    },
    quantityInProgress(item) {
      const outstatding = (item.quantity_pending || 0) - (item.quantity_delivered || 0);

      if (outstatding > 0) {
        return outstatding;
      } else if (parseInt(item.quantity_assigned) === parseInt(item.quantity_delivered)) {
        return item.quantity_delivered
      }

      return 0;
    },

    onSelect(e, item) {
      const isChecked = e.target.checked

      if (isChecked) {
        if (!this.isSplit) {
          const splitItem = cloneDeep(item)

          splitItem.quantity_splited = item.quantity_pending;
          this.$emit('selected', splitItem)
        }
      } else {
        this.$emit('removed', item)
      }
    },

    isDisabled(item) {

      if (item.delivered) {
        return true
      }
      if (this.canHandoverItemsToCustomer) {
        return false
      }
      if (!this.isSplit && this.enabled && item.original_quantity > 0) {
        return false;
      }
      return item.quantity_pending <= 0
    },

    onQuantityChange(item) {
      if (item.quantity_splited > item.quantity_pending) {
        item.quantity_splited = item.quantity_pending
      }
    },

    fetchAvailableQty(item) {
      this.available_qty.loaded = false;
      this.$http.get(this.route('ajax.order_item.quantity',{
        order_id:this.orderId,
        item_code:item.item_code,
        unit: item.unit,
        warehouse_id: item.warehouse_id
      })).then((response) => {

        let existing = this.available_qty.items[response.data.item_code] || {}
        this.available_qty.items = {
          ...this.available_qty.items,
          [response.data.item_code] : {
            ...existing,
            [response.data.unit] : response.data,
          }
        };
        this.available_qty.loaded = true;
      })
    }
  },
}
</script>
